import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";

import useModal from "../../hooks/ModalHook";
import { AuthState } from "../../types/auth.types";

import { handleTileClick } from "./Dashboard.handlers";
import { formatCurrentDate, extractFirstName } from "./Dashboard.utils";

export const useDashboard = () => {
  const auth = useAuth() as AuthState;
  const navigate = useNavigate();
  const { modalOpen, openModal, closeModal, proceedToDestination } = useModal();

  const firstName = extractFirstName(auth.user?.profile.given_name);
  const formattedDate = formatCurrentDate();

  // The onTileClick wrapper binds openModal and navigate to handleTileClick to keep Dashboard.tsx free of navigation logic.
  const onTileClick = (path: string, requiresLoa: boolean) => {
    handleTileClick(path, requiresLoa, openModal, navigate);
  };

  return {
    firstName,
    formattedDate,
    modalOpen,
    closeModal,
    proceedToDestination,
    onTileClick,
  };
};
